import ClientRequest from '@/models/clientRequest';
import axios from 'axios';
import { getAccessToken } from '@/auth/msalInstance';

const baseURL = process.env.VUE_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: baseURL
});

axiosInstance.interceptors.request.use(
    async (config) => {
        try {
            const token = await getAccessToken();
            config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
            console.error('Error getting access token:', error);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const api = {
    getClients: async () => {
        try {
            const response = await axiosInstance.get('/customer');
            return response.data;
        } catch (error) {
            console.error('Error fetching clients:', error);
            throw error;
        }
    },

    addClient: async (clientRequest: ClientRequest) => {
        try {
            const response = await axiosInstance.post('/customer', clientRequest);
            console.log(response.data);
            return response.data;
        } catch (error) {
            console.error('Error adding client:', error);
            throw error;
        }
    },

    getClient: async (id: string) => {
        try {
            const response = await axiosInstance.get(`/customer/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching client:', error);
            throw error;
        }
    },

    deleteClient: async (id: string) => {
        try {
            await axiosInstance.delete(`/customer/${id}`);
        } catch (error) {
            console.error('Error deleting client:', error);
            throw error;
        }
    },

    deleteError: async (customerId: string, errorId: string) => {
        try {
            await axiosInstance.delete(`/customer/${customerId}/errors/${errorId}`);
        } catch (error) {
            console.error('Error deleting error:', error);
            throw error;
        }
    },

    downloadReport: async (id: string) => {
        try {
            const response = await axiosInstance.get(`/customer/${id}/report`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading report:', error);
            throw error;
        }
    },

    getActivities: async () => {
        try {
            const response = await axiosInstance.get('/customer/activities');
            return response.data;
        } catch (error) {
            console.error('Error fetching activities:', error);
            throw error;
        }
    }
};
